import React from 'react';

import { flagStyles } from '../settings';

const SvgHK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2232px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgHK;
